<!--
  File : StudioInfo.vue
-->

<template>
  <v-container fluid>
    <v-row justify="center">
      <v-card class="ma-3 elevation-0" width="480">
        <v-toolbar class="elevation-0" color="white">
          <v-toolbar-title class="primary--text">스튜디오 정보 수정</v-toolbar-title>
        </v-toolbar>
        <v-card-text v-if="studio">
          <v-form>
            <v-text-field
              prepend-icon="mdi-map-marker"
              label="스튜디오"
              v-model="studio.text"
              disabled
            />
            <v-text-field
              id="name"
              prepend-icon="mdi-wan"
              type="name"
              label="홈페이지"
              v-model="studio.link"
            />
            <v-text-field
              id="phone"
              prepend-icon="mdi-phone"
              label="전화번호"
              v-model="studio.phone"
            />
            <v-text-field
              id="address"
              prepend-icon="mdi-home"
              type="text"
              label="주소"
              v-model="studio.address"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-col class="text-right" cols="12">
            <v-btn class="mr-3 elevation-0" color="normal" @click.prevent="cancel()">취소</v-btn>
            <v-btn color="secondary" elevation="0" @click.prevent="update()">적용</v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import util from '../utils/util'

export default {
  data () {
    return {
      login: null,
      studio: null
    }
  },

  props: {
    source: String,
  },

  methods: {
    update: function () {
      if (this.studio.link.trim().length < 2) {
        document.getElementById('link').focus()
        return
      }
      if (this.studio.phone.trim().length < 10) {
        document.getElementById('phone').focus()
        return
      }
      let params = new URLSearchParams()
      params.append('id', this.studio.value)
      params.append('link', this.studio.link.trim())
      params.append('phone', this.studio.phone.trim())
      params.append('address', this.studio.address ? this.studio.address.trim() : '')
      axios.post('/api/studio/update', params, util.headers)
      .then(response => {
        if (response.data.error) {
          console.log(response.data.error)
        }
        else if (response.data.result == 'success') {
          alert('스튜디오 정보가 변경되었습니다.')
          this.$router.push('/')
        }
        else {
          alert('스튜디오 정보를 수정할 수 없습니다.')
        }
      })
    },

    cancel: function () {
      this.$router.push('/')
    },

    change: function () {
      this.$router.push('/change')
    }
  },

  created () {
    console.clear()
    let json = localStorage.getItem('login')
    if (json) {
      this.login = JSON.parse(localStorage.getItem('login'))
    }
    if (this.login) {
      this.$emit('login', this.login)

      util.getStudios((studios, error) => {
        if (error) console.log(error)
        this.studio = util.getItem(studios, this.login.studio)      
      })
    }
    else {
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
</style>
